<ng-template #zipName>
  <span>
    Nom du ZIP
    <vitamui-order-by-button [(direction)]="direction" [(orderBy)]="orderBy" orderByKey="zipName"></vitamui-order-by-button>
  </span>
</ng-template>
<ng-template #size>
  <span>
    Poids
    <vitamui-order-by-button [(direction)]="direction" [(orderBy)]="orderBy" orderByKey="size"></vitamui-order-by-button>
  </span>
</ng-template>
<ng-template #compression>
  <span>
    Compression
    <vitamui-order-by-button [(direction)]="direction" [(orderBy)]="orderBy" orderByKey="compression"> </vitamui-order-by-button>
  </span>
</ng-template>
<ng-template #loading>
  <span>
    Chargement
    <vitamui-order-by-button [(direction)]="direction" [(orderBy)]="orderBy" orderByKey="loading"></vitamui-order-by-button>
  </span>
</ng-template>

<h2>{{ 'ARRAY.NEW_TABLES' | translate }}</h2>
<h3>{{ 'ARRAY.HEADER' | translate }}</h3>
<vitamui-sup-header>
  <ng-container title>{{ 'ARRAY.EXPORT_RESULTS' | translate }}</ng-container>
  <ng-container buttons>
    <button class="btn link pr-2">{{ 'ARRAY.EXPORT_RESULTS' | translate }}</button>
    <button class="btn btn-circle large tertiary"><i class="vitamui-icon vitamui-icon-import-csv"></i></button>
    <vitamui-menu-button class="pl-2" menuButtonSize="medium" overlayPos="end" icon="vitamui-icon-more-horiz">
      <button mat-menu-item>Activer</button>
      <button mat-menu-item>Désactiver</button>
    </vitamui-menu-button>
  </ng-container>
</vitamui-sup-header>
<h3>{{ 'ARRAY.TABLE' | translate }}</h3>
<table>
  <thead>
    <tr>
      <th>
        <ng-container *ngTemplateOutlet="zipName"></ng-container>
      </th>
      <th>
        <ng-container *ngTemplateOutlet="size"></ng-container>
      </th>
      <th>
        <ng-container *ngTemplateOutlet="compression"></ng-container>
      </th>
      <th>
        <ng-container *ngTemplateOutlet="loading"></ng-container>
      </th>
    </tr>
  </thead>
  <tbody>
    @for (row of tableDataSource; track row) {
      <tr class="clickable" [class.selected]="row === selectedRow" (click)="selectedRow = row">
        <td>{{ row.zipName }}</td>
        <td>{{ row.size }}</td>
        <td>
          <mat-progress-bar [value]="row.compression" class="stepper-progress-bar" mode="determinate"></mat-progress-bar>
        </td>
        <td>
          <mat-progress-bar [value]="row.loading" class="stepper-progress-bar" mode="determinate"></mat-progress-bar>
        </td>
      </tr>
    }
  </tbody>
</table>

<h3>{{ 'ARRAY.MAT_TABLE' | translate }}</h3>
<table mat-table [dataSource]="tableDataSource">
  <ng-container matColumnDef="zipName">
    <th mat-header-cell *matHeaderCellDef>
      <ng-container *ngTemplateOutlet="zipName"></ng-container>
    </th>
    <td mat-cell *matCellDef="let element">{{ element.zipName }}</td>
  </ng-container>
  <ng-container matColumnDef="size">
    <th mat-header-cell *matHeaderCellDef>
      <ng-container *ngTemplateOutlet="size"></ng-container>
    </th>
    <td mat-cell *matCellDef="let element">{{ element.size }}</td>
  </ng-container>
  <ng-container matColumnDef="compression">
    <th mat-header-cell *matHeaderCellDef>
      <ng-container *ngTemplateOutlet="compression"></ng-container>
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-progress-bar [value]="element.compression" class="stepper-progress-bar" mode="determinate"></mat-progress-bar>
    </td>
  </ng-container>
  <ng-container matColumnDef="loading">
    <th mat-header-cell *matHeaderCellDef>
      <ng-container *ngTemplateOutlet="loading"></ng-container>
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-progress-bar [value]="element.loading" class="stepper-progress-bar" mode="determinate"></mat-progress-bar>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    class="clickable"
    [class.selected]="row === selectedRow"
    (click)="selectedRow = row"
  ></tr>
</table>

<div>
  <h2>{{ 'ARRAY.OLD_TABLES' | translate }}</h2>
  <div class="vitamui-table">
    <div class="vitamui-table-head">
      <div class="col-2">
        <i class="vitamui-icon vitamui-icon-gestion-de-profil"></i>
      </div>
      <div class="col-3">{{ 'ARRAY.COLUMN.ADMIN_PROFILE_NAME' | translate }}</div>
      <div class="col-2">{{ 'ARRAY.COLUMN.ID' | translate }}</div>
      <div class="col-3">{{ 'ARRAY.COLUMN.DESCRIPTION' | translate }}</div>
      <div class="col-2">{{ 'ARRAY.COLUMN.LEVEL' | translate }}</div>
    </div>

    <div class="vitamui-table-body">
      @for (profile of dataSource; track profile) {
        <div class="vitamui-table-rows" (click)="handleClick(profile)">
          <div class="vitamui-row d-flex align-items-center clickable">
            <div class="col-2">
              <i
                class="vitamui-icon vitamui-icon-gestion-de-profil"
                [ngClass]="profile?.enabled ? 'status-badge-green' : 'status-badge-grey'"
              ></i>
            </div>
            <div class="col-3" vitamuiCommonEllipsis>{{ profile.name }}</div>
            <div class="col-2" vitamuiCommonEllipsis>{{ profile.identifier }}</div>
            <div class="col-3" vitamuiCommonEllipsis>{{ profile.description }}</div>
            <div class="col-2" vitamuiCommonEllipsis>{{ profile.level }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div>
  <h2>{{ 'ARRAY.BASIC_WITH_DOUBLE_LINES_TITLE' | translate }}</h2>
  <div class="vitamui-table">
    <div class="vitamui-table-head">
      <div class="col-2">
        <i class="vitamui-icon vitamui-icon-gestion-de-profil"></i>
      </div>
      <div class="col-3">{{ 'ARRAY.COLUMN.ADMIN_PROFILE_NAME' | translate }}</div>
      <div class="col-2">{{ 'ARRAY.COLUMN.ID' | translate }}</div>
      <div class="col-3">{{ 'ARRAY.COLUMN.DESCRIPTION' | translate }}</div>
      <div class="col-2">{{ 'ARRAY.COLUMN.LEVEL' | translate }}</div>
    </div>

    <div class="vitamui-table-body">
      @for (profile of dataSource; track profile) {
        <div class="vitamui-table-rows" (click)="handleClick(profile)">
          <div class="vitamui-row d-flex align-items-center clickable">
            <div class="col-2">
              <i
                class="vitamui-icon vitamui-icon-gestion-de-profil"
                [ngClass]="profile?.enabled ? 'status-badge-green' : 'status-badge-grey'"
              ></i>
            </div>
            <div class="col-3">
              <div vitamuiCommonEllipsis>{{ profile.name }}</div>
              <div vitamuiCommonEllipsis class="text normal light">{{ profile.name }}</div>
            </div>
            <div class="col-2" vitamuiCommonEllipsis>{{ profile.identifier }}</div>
            <div class="col-3" vitamuiCommonEllipsis>{{ profile.description }}</div>
            <div class="col-2" vitamuiCommonEllipsis>{{ profile.level }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div>
  <h2>{{ 'ARRAY.FILTER_TITLE' | translate }}</h2>
  <div class="vitamui-table">
    <div class="vitamui-table-head">
      <div class="col-2 d-flex align-items-center">
        <button class="vitamui-filter-button" [vitamuiCommonTableFilter]="statusFilterTemplate">
          <i class="material-icons vitamui-row-icon">filter_list</i>
        </button>

        <ng-template #statusFilterTemplate>
          <vitamui-common-table-filter [(filter)]="filterMap['status']" (filterChange)="onFilterChange('status', $event)">
            <vitamui-common-table-filter-option value="ENABLED">
              <div class="table-filter-icon">
                <span class="badge-state">{{ 'ARRAY.COLUMN.STATUS.ENABLED' | translate }}</span>
              </div>
            </vitamui-common-table-filter-option>
            <vitamui-common-table-filter-option value="DISABLED">
              <div class="table-filter-icon">
                <span class="badge-state">{{ 'ARRAY.COLUMN.STATUS.DISABLED' | translate }}</span>
              </div>
            </vitamui-common-table-filter-option>
          </vitamui-common-table-filter>
        </ng-template>

        <i class="vitamui-icon vitamui-icon-keys vitamui-row-icon"></i>
        <vitamui-order-by-button orderByKey="status" [(orderBy)]="orderBy" [(direction)]="direction"> </vitamui-order-by-button>
      </div>

      <div class="col-3 d-flex align-items-center">
        <span>{{ 'ARRAY.COLUMN.GROUP_NAME' | translate }}</span>
        <vitamui-order-by-button orderByKey="name" [(orderBy)]="orderBy" [(direction)]="direction"></vitamui-order-by-button>
      </div>

      <div class="col-2 d-flex align-items-center">
        <span>{{ 'COMMON.ID' | translate }}</span>
        <vitamui-order-by-button orderByKey="identifier" [(orderBy)]="orderBy" [(direction)]="direction"> </vitamui-order-by-button>
      </div>

      <div class="col-3 d-flex align-items-center">
        <span>{{ 'ARRAY.COLUMN.DESCRIPTION' | translate }}</span>
        <vitamui-order-by-button orderByKey="description" [(orderBy)]="orderBy" [(direction)]="direction"> </vitamui-order-by-button>
      </div>

      <div class="col-2 d-flex align-items-center">
        <button
          class="vitamui-filter-button"
          [vitamuiCommonTableFilter]="levelFilterTemplate"
          [class.active]="filterMap['level'] && filterMap['level'].length > 0"
          #levelFilterTrigger="vitamuiCommonTableFilter"
        >
          <i class="material-icons vitamui-row-icon">filter_list</i>
        </button>

        <ng-template #levelFilterTemplate>
          <vitamui-common-table-filter-search
            [(filter)]="filterMap['level']"
            [options]="levelFilterOptions"
            (filterChange)="onFilterChange('level', $event)"
            (filterClose)="levelFilterTrigger?.close()"
            emptyValueOption="-Niveau vide-"
          >
          </vitamui-common-table-filter-search>
        </ng-template>

        <span>{{ 'ARRAY.COLUMN.LEVEL' | translate }}Niveau</span>
        <vitamui-order-by-button orderByKey="level" [(orderBy)]="orderBy" [(direction)]="direction"> </vitamui-order-by-button>
      </div>
    </div>

    <div class="vitamui-table-body">
      @for (group of dataSource; track group) {
        <div class="vitamui-table-rows" (click)="handleClick(group)">
          <div class="vitamui-row d-flex align-items-center clickable">
            <div class="col-2 d-flex align-items-center">
              <i class="vitamui-icon vitamui-icon-keys pl-4" [ngClass]="group?.enabled ? 'status-badge-green' : 'status-badge-grey'"> </i>
            </div>
            <div class="col-3" vitamuiCommonEllipsis>{{ group.name }}</div>
            <div class="col-2" vitamuiCommonEllipsis>{{ group.identifier }}</div>
            <div class="col-3" vitamuiCommonEllipsis>{{ group.description }}</div>
            <div class="col-2" vitamuiCommonEllipsis>{{ group.level }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div>
  <h2>{{ 'ARRAY.SUBTABLE_TITLE' | translate }}</h2>
  <div class="vitamui-table">
    <div class="vitamui-table-head">
      <div class="col-2"><i class="vitamui-icon vitamui-icon-bank"></i></div>
      <div class="col-3">
        {{ 'ARRAY.COLUMN.ADMIN_PROFILE_NAME' | translate }}
      </div>
      <div class="col-2">{{ 'ARRAY.COLUMN.ID' | translate }}</div>
      <div class="col-3">{{ 'ARRAY.COLUMN.DESCRIPTION' | translate }}</div>
      <div class="col-2">{{ 'ARRAY.COLUMN.LEVEL' | translate }}</div>
    </div>

    <div class="vitamui-table-body">
      <div class="vitamui-table-rows">
        @for (customer of dataSource; track customer) {
          <div
            class="vitamui-row"
            [vitamuiCommonCollapse]
            #row="vitamuiCommonCollapse"
            [class.no-hover]="row.state === 'expanded'"
            (click)="handleClick(customer)"
          >
            <div class="d-flex align-items-center clickable">
              <div class="col-2 d-flex" (click)="$event.stopPropagation(); row.toggle()">
                <i class="vitamui-icon vitamui-icon-bank"></i>
                <i class="material-icons caret ml-1 rotate" [style.fontSize.px]="20" [class.collapsed]="row.state === 'collapsed'"
                  >keyboard_arrow_up</i
                >
              </div>
              <div class="col-3" vitamuiCommonEllipsis>{{ customer?.name }}</div>
              <div class="col-2" vitamuiCommonEllipsis>{{ customer?.identifier }}</div>
              <div class="col-3" vitamuiCommonEllipsis>{{ customer?.description }}</div>
              <div class="col-2 actions">
                <span vitamuiCommonEllipsis>{{ customer?.level }}</span>
                <div>
                  <button class="btn btn-circle primary" (click)="$event.stopPropagation(); openDialog('button')">
                    <i class="vitamui-icon vitamui-icon-key-plus btn-icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          @if (row.state === 'expanded') {
            <div class="vitamui-subtable p-0">
              <div class="vitamui-table-head">
                <div class="col-3"></div>
                <div class="col-2">Code propriétaire</div>
                <div class="col-3">Propriétaire</div>
                <div class="col-2">Code coffre</div>
                <div class="col-4"></div>
              </div>
              <div class="vitamui-table-body">
                <div class="vitamui-table-rows">
                  @for (tenant of dataSource; track tenant) {
                    <div class="vitamui-row d-flex align-items-center clickable" (click)="handleClick(tenant)">
                      <div class="col-3 d-flex justify-content-center align-items-end"></div>
                      <div class="col-2" vitamuiCommonEllipsis>{{ tenant.identifier }}</div>
                      <div class="col-3" vitamuiCommonEllipsis>{{ tenant.name }}</div>
                      <div class="col-2" vitamuiCommonEllipsis>{{ tenant.description }}</div>
                    </div>
                  }
                </div>
                <div class="footer-action">
                  <span class="clickable">{{ 'ARRAY.ADD_OWNER' | translate }}</span>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>

<div>
  <h2>{{ 'ARRAY.DIALOG_TITLE' | translate }}</h2>
  <div class="vitamui-table">
    <div class="vitamui-table-head p-0 py-3 d-flex align-items-center">
      <div class="pl-4">Groupe de profil</div>
    </div>

    <div class="vitamui-table-body">
      <div class="vitamui-table-rows">
        @for (group of dataSource; track group) {
          <div
            class="vitamui-row p-0 px-4"
            [class.no-hover]="row.state === 'expanded'"
            [vitamuiCommonCollapse]
            #row="vitamuiCommonCollapse"
          >
            <div class="d-flex justify-content-between align-items-center clickable" (click)="handleClick(group)">
              <div class="row-label align-items-center" vitamuiCommonEllipsis>
                {{ group?.name }}
              </div>
              <button class="btn link underline" (click)="$event.stopPropagation(); row.toggle()">
                {{ row.state === 'collapsed' ? 'Voir detail' : 'Masquer detail' }}
              </button>
            </div>
            @if (row.state === 'expanded') {
              <div class="vitamui-subtable p-0">
                <div class="vitamui-table-head">
                  <div class="col-4">Prop1</div>
                  <div class="col-4">Prop2</div>
                  <div class="col-4">Prop3</div>
                </div>
                <div class="vitamui-table-body">
                  <div class="vitamui-table-rows">
                    <div class="vitamui-row d-flex align-items-center clickable">
                      <div class="col-4" vitamuiCommonEllipsis>Value 1</div>
                      <div class="col-4" vitamuiCommonEllipsis>Value 2</div>
                      <div class="col-4" vitamuiCommonEllipsis>Value 3</div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
